import { render, staticRenderFns } from "./addConfig.vue?vue&type=template&id=f3838a6c&scoped=true"
import script from "./addConfig.vue?vue&type=script&lang=js"
export * from "./addConfig.vue?vue&type=script&lang=js"
import style0 from "./addConfig.vue?vue&type=style&index=0&id=f3838a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3838a6c",
  null
  
)

export default component.exports